import { FC } from 'react';
import styled from 'styled-components';
import { GenericContainerCard, SideSpace } from '../UtilitiesMatchMobile/GenericCssComponentMatchMobile';
import CenterInfoFightRendering from '../UtilitiesMatchMobile/GenericRendering/CenterInfoFightRendering';
import RenderWrestlerWhenTwoInSpace from './RenderWrestlerBySpaceAndNumber/RenderWrestlerWhenTwoInSpace';
import RenderingMatchWithConditionExtended from '../UtilitiesMatchMobile/RenderingMatchWithConditionExtended';
import { Match } from '../../../../types';

export const WrapperSideSpace = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
`;

interface FatalFourMatchRenderProps {
    matchInfo: Match;
    withWinner?: boolean;
    isExpanded?: boolean;
}

const FatalFourMatchRender: FC<FatalFourMatchRenderProps> = ({ matchInfo, withWinner = false, isExpanded = false }) => {
    // Divido matchInfo.wrestlers in due array uguale.. se dispari, il primo array avra' un elemento in più
    const wrestlers1 = matchInfo.wrestlers.slice(0, Math.ceil(matchInfo.wrestlers.length / 2));
    const wrestlers2 = matchInfo.wrestlers.slice(Math.ceil(matchInfo.wrestlers.length / 2));

    function renderGenericContainerCard() {
        return (
            <GenericContainerCard
             className='fatal-four-match-render'
             height={isExpanded ? '80%' : '100%'}
            >
                <SideSpace className='side-space'>

                    <WrapperSideSpace className='wrapper-side-space'>
                        {wrestlers1.map((wrestler, index) => (
                            <RenderWrestlerWhenTwoInSpace
                             wrestler={wrestler}
                             side='left'
                             key={index}
                             withWinner={withWinner}
                            />
                        ))}
                    </WrapperSideSpace>

                </SideSpace>
                <CenterInfoFightRendering matchInfo={matchInfo} typeMatch='Fatal 4-Way' />
                <SideSpace className='side-space'>

                    <WrapperSideSpace className='wrapper-side-space'>
                        {wrestlers2.map((wrestler, index) => (
                            <RenderWrestlerWhenTwoInSpace
                             wrestler={wrestler}
                             side='right'
                             key={index}
                             withWinner={withWinner}
                            />
                        ))}
                    </WrapperSideSpace>

                </SideSpace>
            </GenericContainerCard>
        )
    }

    return (
        RenderingMatchWithConditionExtended({ renderGenericContainerCard, isExpanded, matchInfo })
    )
}

export default FatalFourMatchRender;
